import React, { Component } from 'react';
import { Button, Breadcrumb, DatePicker, Select, Divider } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import '../../FundMonitoring.css';
import CiticRiskMonitoringGrid from './CiticRiskMonitoringGrid';

const { Option } = Select;

class CiticRiskMonitoringDashboard extends Component {

    onInputChange = ({ name, value }) => {
        this.props.citicRiskMonitoringSearchChangeInput({ name, value });
    };

    queryData = () => {
        const { citicRiskMonitoringSearchFields } = this.props;
        this.props.queryCiticRiskMonitoring(citicRiskMonitoringSearchFields);
    }

    render() {
        const {
            queryCiticRiskMonitoringStatus,
            citicRiskMonitoringSearchFields,
        } = this.props;

        const { fundCode, date } = citicRiskMonitoringSearchFields;
        const isLoading = queryCiticRiskMonitoringStatus === ACTION_STATUS.LOGINING;

        return (
            <div className="tradesReviewWrapper">
                <div className='breadcrumbWrapper'>
                    <Breadcrumb>
                        <Breadcrumb.Item>Fund Monitoring</Breadcrumb.Item>
                        <Breadcrumb.Item>Fund Risk Monitoring</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className='operationBar'>
                    <DatePicker 
                        style={{ marginLeft: 10 }}
                        size='small'
                        allowClear={false}
                        placeholder='Select Date'
                        value={date}
                        onChange={(date) => this.onInputChange({ name: 'date', value: date })} 
                    />
                    <Select 
                        style={{ width: 120, marginLeft: 10 }}
                        size='small'
                        placeholder="Fund Code"
                        value={fundCode}
                        onChange={(val) => this.onInputChange({ name: 'fundCode', value: val })}
                    >
                        <Option value="">All</Option>
                        <Option value="CVF">CVF</Option>
                        <Option value="SLHL">SLHL</Option>
                        <Option value="ZJNF">ZJNF</Option>
                        <Option value="DCL">DCL</Option>
                    </Select>
                    <Button type="primary" 
                        onClick={this.queryData} 
                        loading={isLoading}
                        style={{ marginLeft: 10 }} 
                        size="small"
                        icon="search"
                    >
                        Query
                    </Button>
                </div>

                <div className='tradesReviewGrid' style={{ marginTop: 20 }}>
                    <CiticRiskMonitoringGrid {...this.props} />
                </div>
            </div>
        );
    }
}

export default CiticRiskMonitoringDashboard;
